import confirmationModalTemplate from 'modals/confirmation/template.html';
import addTrackerModalTemplate from 'modals/addTracker/template.html';

function ModalServiceFn($uibModal, $q) {
  class ModalService {
    confirmation(options) { //eslint-disable-line
      if (!options) throw new Error('modalService - confirmation() - options is required');
      if (!options.modalMessage) throw new Error('modalService - confirmation() - options.modalMessage is required');

      const deferred = $q.defer();

      const modalInstance = $uibModal.open({
        template: confirmationModalTemplate,
        controller: 'confirmationModalCtrl',
        size: options.size || 'md',
        resolve: {
          modalHeader: function() {
            return options.modalHeader || null;
          },
          modalMessage: function() {
            return options.modalMessage || null;
          },
          confirmingBtnClass: function() {
            return options.confirmingBtnClass || null;
          },
          confirmBtnTxt: function() {
            return options.confirmBtnTxt || null;
          },
          confirmingBtnTxt: function() {
            return options.confirmingBtnTxt || null;
          },
          hideCancelBtn: function() {
            return options.hideCancelBtn || false;
          },
          cancelBtnTxt: function() {
            return options.cancelBtnTxt || null;
          },
          deferred: function() {
            return deferred;
          }
        }
      });

      return $q((resolve, reject) => {
        deferred.promise
          .then(result => {
            if (result === false) {
              return modalInstance.close(null);
            }

            return resolve({
              confirm: result,
              modalInstance: modalInstance
            });
          })
          .catch(_catchModalError(reject));
      });
    }

    addTracker(options) { //eslint-disable-line
      if (!options) throw new Error('modalService - confirmation() - options is required');

      const deferred = $q.defer();

      const modalInstance = $uibModal.open({
        template: addTrackerModalTemplate,
        controller: 'addTrackerModalCtrl',
        size: options.size || 'md',
        resolve: {
          affiliateId: function() {
            return options.affiliateId;
          },
          deferred: function() {
            return deferred;
          }
        }
      });

      return $q((resolve, reject) => {
        deferred.promise
          .then(result => {
            if (result === false) {
              return modalInstance.close(null);
            }

            return resolve({
              tracker: result,
              modalInstance: modalInstance
            });
          })
          .catch(_catchModalError(reject));
      });
    }
  }

  /**
   * @param {Function} reject
   */
  function _catchModalError(reject) {
    return function(error) {
      if (error && (error === 'backdrop click' || error === 'escape key press')) return; //just eat these because they aren't really errors

      reject(error);
    };
  }

  return new ModalService();
}

ModalServiceFn.$inject = [
  '$uibModal',
  '$q'
];

export default ModalServiceFn;



// WEBPACK FOOTER //
// ./src/services/modalService.js